export interface GDPRSettings {
	enable_cookie_banner?: boolean;
	cookie_banner_background_override?: string;
}

export const COOKIES_ACCEPTED_INDEX_DB = 'COOKIES_ACCEPTED';
